export default {"src":"/_next/static/media/shipping7.0071fc9b.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};